<template>
    <div class="flex-box nopadding tleft">
        <div class="text-nowrap text-hd"><span class="mg-right3">{{$t('org_self')}}</span><Checkbox v-model="org_self" @on-change="onOrgSelfChange"></Checkbox></div>
        <Cascader :class="org_class" v-model="org_select" :filterable="true" @on-change="onSelectOrg" :placeholder="$t('select_org_down')" :data="orgs"></Cascader>
    </div>
</template>

<script>
    export default {
        name: "myOrgSelfAndDown",
        data:function(){
            return{
                org_select: [],
                org_self: true
            }
        },
        props:{
            orgs: {
                default: [],
                type: Array,
            },
            org_class: {
                default: 'w200',
                type: String,
            }
        },
        methods: {
            onOrgSelfChange () {
                if (this.org_self) {
                    this.org_select = [];

                    this.$emit('onChange', {org_id:''});
                }
            },
            onSelectOrg (data) {
                var org_id = '';
                if(data.length > 2){
                    org_id = data[2];
                    if (org_id == '') {
                        org_id = data[1];
                        if (org_id == '') {
                            org_id = data[0];
                        }
                    }
                }
                else if(data.length > 1){
                    org_id = data[1];
                    if (org_id == '') {
                        org_id = data[0];
                    }
                }
                else if(data.length > 0){
                    org_id = data[0];
                }
                this.org_self = org_id == ''?true:false;

                this.$emit('onChange', {org_select:data,org_id: org_id});
            },
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/myOrgSelfAndDown.vue